import { getContentfulAsset } from '~/libs/contentful/helpers'
import { StructuredSchema } from '../StructuredSchema'
import { TypeVideoUpload } from '~/types/contentful'

export type VideoProps = React.HTMLAttributes<HTMLVideoElement> & {
  asset?: TypeVideoUpload<'WITHOUT_UNRESOLVABLE_LINKS', string> | string
  className?: string
  width?: number | string
  height?: number | string
  loop?: boolean
  autoPlay?: boolean
  muted?: boolean
  controls?: boolean
}

export const Video = ({
  asset,
  className,
  width,
  height,
  loop,
  autoPlay,
  muted,
  controls,
}: VideoProps) => {
  if (!asset) return <></>

  if (typeof asset === 'string') {
    return (
      <video
        className={className}
        loop={loop || false}
        autoPlay={autoPlay || false}
        muted={muted || true}
        width={width || '100%'}
        height={height || '100%'}
        src={asset}
        controls={controls || true}
        poster={asset}
      />
    )
  } else {
    const videoAsset = getContentfulAsset(asset.fields?.video)
    const thumbnailAsset = getContentfulAsset(asset.fields?.thumbnail)
    if (!videoAsset || !videoAsset.fields.file) return null

    const thumbnailUrl = thumbnailAsset?.fields?.file?.url

    return (
      <>
        <StructuredSchema
          schema={{
            '@context': 'https://schema.org',
            '@type': 'VideoObject',
            name: asset.fields?.title,
            description: asset.fields?.videoDescription,
            uploadDate: asset.sys.createdAt,
            thumbnailUrl: thumbnailUrl ? [thumbnailUrl] : [],
          }}
        />
        <video
          className={className}
          loop={loop || false}
          autoPlay={autoPlay || false}
          muted={muted || true}
          width={width || '100%'}
          height={height || '100%'}
          src={videoAsset?.fields.file?.url}
          controls={controls || true}
          poster={thumbnailAsset?.fields?.file?.url}
        />
      </>
    )
  }
}
